import { ISelf } from '@models/account';
import {
  IChannelListData,
  ILectureListData,
  ILiveroomData,
  IGroupPageListData
} from '@models/contrains';
import { createContext } from 'react';

export const AccountContext = createContext<ISelf>(null as any);
export const LiveroomContext = createContext<ILiveroomData>(null as any);
export const ChannelListContext = createContext<IChannelListData | null>(null);
export const LectureListContext = createContext<ILectureListData | null>(null);
export const GroupPageListContext = createContext<IGroupPageListData | null>(null);



// WEBPACK FOOTER //
// ./src/services/context.ts